export default "__VITE_ASSET__56a4a639__"